import { CrudListView, PageContainer } from '@startupquickstart/frontend';
import { languageCrudConfig } from '@/config/objects/languages';

export function LanguagesPage() {
  const breadcrumbs = [
    { label: 'Home', href: '/' },
    { label: 'Languages', current: true },
  ];

  return (
    <PageContainer>
      <CrudListView
        config={languageCrudConfig}
        baseUrl="/languages"
        breadcrumbs={breadcrumbs}
      />
    </PageContainer>
  );
}
